const getEnvValue = (
  viteKey: keyof ImportMetaEnv,
  reactKey: keyof ImportMetaEnv,
): string => {
  const value = import.meta.env[viteKey] ?? import.meta.env[reactKey] ?? "";
  return value.trim();
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  UserBaseUrl: getEnvValue("VITE_BASE_URL", "REACT_APP_BASE_URL"),
  msalAuthorityDomain: getEnvValue(
    "VITE_MSAL_AUTHORITY_DOMAIN",
    "REACT_APP_MSAL_AUTHORITY_DOMAIN",
  ),
  msalAuthorityURL: getEnvValue(
    "VITE_MSAL_AUTHORITY_URL",
    "REACT_APP_MSAL_AUTHORITY_URL",
  ),
  msalClientID: getEnvValue("VITE_MSAL_CLIENT_ID", "REACT_APP_MSAL_CLIENT_ID"),
  msalReadScope: getEnvValue(
    "VITE_MSAL_READ_SCOPES",
    "REACT_APP_MSAL_READ_SCOPES",
  ),
  msalWriteScope: getEnvValue(
    "VITE_MSAL_WRITE_SCOPES",
    "REACT_APP_MSAL_WRITE_SCOPES",
  ),
  UserVersion: getEnvValue("VITE_VERSION", "REACT_APP_VERSION"),
  WebAppCurrentYear: getEnvValue("VITE_YEAR", "REACT_APP_YEAR"),
  SignalRTestRouteSecret: getEnvValue(
    "VITE_SIGNALR_TEST_ROUTE_SECRET",
    "REACT_APP_SIGNALR_TEST_ROUTE_SECRET",
  ),
};
